<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <h4 class="font-weight-bold">Répliquer les créneaux sur les jours de la semaine</h4>
      </v-col>
      <v-row no-gutters>
        <v-col
          v-for="day in days"
          :key="`day_${day.value}`"
          class="flex-auto"
        >
          <v-checkbox
            v-model="sessionReplica.replica_interval"
            :label="day.label"
            :value="day.value"
            color="third"
            :disabled="isRadioGroupDisable"
          />
        </v-col>
      </v-row>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <h4 class="font-weight-bold">Exclure le créneau pour les semaines</h4>
      </v-col>
      <v-row no-gutters class="overflow-y-hidden">
        <v-col
          v-for="week in weeks"
          :key="`week_${week.year}_${week.value}`"
          cols="3"
        >
          <v-checkbox
            v-model="sessionReplica.replica_weeks"
            :label="week.label"
            :value="week.value"
            color="third"
            hide-details
            :disabled="isRadioGroupDisable"
          />
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import { ref, computed, inject } from '@vue/composition-api';
import { eachDayOfInterval, startOfWeek, endOfWeek, format, eachWeekOfInterval, add, getISOWeek, getYear } from 'date-fns';
import { fr } from 'date-fns/esm/locale';
import store from '@/store';
import { isObjectEmpty } from '@/helpers/utils';

export default {
  props: {
    date: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const selectedDays = ref([]);
    const selectedWeeks = ref([]);
    const selectedDate = computed(() => store.getters.selectedDate);
    const sessionReplica = inject('sessionReplica');
    const editable = inject('editable');
    const oldSessionDetail = inject('oldSessionDetail');

    const days = computed(() => {
      const start = startOfWeek(new Date(), { weekStartsOn: 1 });
      const end = endOfWeek(new Date(), { weekStartsOn: 1 });
      const weekDays = eachDayOfInterval({ start, end });
      return weekDays.map(weekDay => {
        const formatedDate = format(weekDay, 'EEEE', { locale: fr });
        return {
          label: `${formatedDate.charAt(0).toUpperCase()}${formatedDate.slice(1, formatedDate.length)}`,
          value: weekDay.getDay()
        };
      });
    });

    const weeks = computed(() => {
      // const end = endOfYear(new Date(selectedDate.value))
      const result = eachWeekOfInterval({
        start: new Date(selectedDate.value),
        end: add(endOfWeek(new Date(props.date)), { days: 1 })
      }, { weekStartsOn: 1 });
      return result.map(week => {
        const yearWeek = getISOWeek(week);
        // const startWeek = startOfWeek(week, { weekStartsOn: 1 });
        // const endWeek = endOfWeek(week, { weekStartsOn: 1 });
        // (${format(startWeek, 'dd MMM', { format: fr })} - ${format(endWeek, 'dd MMM', { format: fr })})
        return {
          label: `${yearWeek}`,
          value: yearWeek,
          year: getYear(week)
        };
      });
    });

    const isRadioGroupDisable = computed(() => editable.value && (oldSessionDetail.value.replica && !isObjectEmpty(oldSessionDetail.value.replica)));

    return { sessionReplica, days, selectedDays, weeks, selectedWeeks, editable, isRadioGroupDisable };
  }
};
</script>
